export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/uploadFiles.worker.883868f6.worker.js");
}
